import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Reveal } from '../ui-custom/Reveal';
import { theme } from '../../utils/theme';

export const CTASection = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  
  return (
    <section className="py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black to-[#111]" />
      
      {/* Glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-orange-500/10 rounded-full blur-[100px] pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 text-center">
        <Reveal>
          <h2 className="text-4xl md:text-6xl font-bold mb-8">
            {t.cta.title}
          </h2>
          <p className="text-xl mb-12 text-gray-400">
            {t.cta.subtitle}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => navigate('/shop')}
              data-testid="cta-buy-btn"
              className="relative px-12 py-6 rounded-full font-bold text-xl transition-all hover:scale-105 overflow-hidden group"
              style={{
                background: theme.gradients.primary,
                color: '#000',
                boxShadow: `0 0 40px -10px ${theme.colors.primary}60`
              }}
            >
              <span className="relative z-10">{t.cta.button}</span>
              <div className="absolute top-0 left-0 w-full h-full bg-white opacity-20 transform -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" />
            </button>
            
            <button 
              onClick={() => navigate('/solution')}
              data-testid="cta-solution-btn"
              className="px-12 py-6 rounded-full font-bold text-xl border transition-all hover:bg-white/5 hover:border-white/40"
              style={{ borderColor: theme.colors.border, color: theme.colors.text }}
            >
              {t.cta.secondaryButton}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
